import {handleError} from '../../../common/utils/errorHandling';
import httpClient from '../../../common/services/httpClient';

export interface GeocodeRequest {
  address: string;
}

export interface GeocodeResult {
  latitude: number;
  longitude: number;
  displayName: string;
}

class GeocodingService {
  public async geocodeAddress(address: string): Promise<GeocodeResult | null> {
    return handleError(
      async () => {
        const request: GeocodeRequest = { address };
        return await httpClient.post<GeocodeResult>('/geocode', request);
      },
      'Error geocoding address:',
      () => null
    );
  }
}

const geocodingService = new GeocodingService();
export default geocodingService;

